import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageLocateUs,
  DeleteLocateUs,
  EditLocateUs,
  GetLocateUs,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";

const LocateUs = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);

  const privilegeId = "19";
  const dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    location_name: Yup.string().trim().required("Location name is required"),
    zone: Yup.string().trim().required("Zone is required"),
    map_link: Yup.string()
      .trim()
      .nullable()
      .test("is-valid-url-or-empty", "Must be a valid URL", (value) => {
        if (!value) return true;
        return Yup.string().url().isValidSync(value);
      }),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetLocateUs({
        callback: (response) => {
          const responseData = response?.data;
          if (responseData && typeof responseData === "object" && !Array.isArray(responseData)) {
            setData([responseData]);
            setTotalData(1);
          } else if (isValidArray(responseData)) {
            setData(responseData);
            setTotalData(responseData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );

    if (array.length === 0) {
      setarray([
        { failed: "id", type: inputType.text, title: "id", customdesign: { display: "none" } },
        { failed: "name", type: inputType.text, title: "Name", placeholder: "Enter name", fullwidth: true },
        { failed: "location_name", type: inputType.text, title: "Location Name", placeholder: "Enter location name", fullwidth: true },
        { failed: "zone", type: inputType.text, title: "Zone", placeholder: "Enter zone (North, Beirut, South...)", fullwidth: true },
        { failed: "map_link", type: inputType.text, title: "Map Link", placeholder: "Enter map link", fullwidth: true },
        { failed: "display_order", type: inputType.number, title: "Display Order", placeholder: "Enter display order", fullwidth: true },
        { failed: "is_active", type: inputType.checkbox, title: "Is Active", fullwidth: true },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "name" },
    { type: columntype.text, name: "location_name" },
    { type: columntype.text, name: "zone" },
    { type: columntype.text, name: "map_link" },
    { type: columntype.text, name: "display_order" },
    { type: columntype.boolean, name: "is_active" },
  ];

  const headCells = [
    { id: "id", label: "ID", withSort: true },
    { id: "name", label: "Name", withSort: false },
    { id: "location_name", label: "Location Name", withSort: false },
    { id: "zone", label: "Zone", withSort: false },
    { id: "map_link", label: "Map Link", withSort: false },
    { id: "display_order", label: "Display Order", withSort: false },
    { id: "is_active", label: "Is Active", withSort: false },
    (dataPrivileges[privilegeId]?.access_edit == 1 || dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      label: "Actions",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (!row) return;
        Commonalert.show({
          title: `Delete ${row?.name ?? "this item"}?`,
          message: "You won't be able to revert this!",
          type: "delete",
          actions: [
            {
              name: "Yes",
              callback: () => dispatch(DeleteLocateUs({ callback: () => GetData(), id: [row?.id] })),
              type: "delete",
            },
            { name: "No", callback: () => {}, type: "cancel" },
          ],
        });
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (row) => {
        setEditMode(true);
        setvalues(row);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditLocateUs({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          setData((prev) => prev.map((item) => (item.id === row.id ? { ...item, [failedName]: newData } : item)));
          setloadingEditdatatype("");
          GetData();
        },
      })
    );
  };

  return (
    <>
      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, type) => tableName && type && GetData({ tableName, type })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              { name: "Yes", callback: () => dispatch(DeleteLocateUs({ callback: () => GetData(), id: ListIds })), type: "delete" },
              { name: "No", callback: () => {}, type: "cancel" },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />

      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Locate Us"}
          editMode={editMode}
          description={editMode ? "Edit Locate Us Entry" : "Add New Locate Us Entry"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(formValues) =>
            dispatch(
              ManageLocateUs({
                editMode,
                values: formValues,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            )
          }
          Schema={Schema}
        />
      )}
    </>
  );
};

export default LocateUs;
